import {createContext} from "react";


const AuthorizationContext = createContext(null);
export default AuthorizationContext;